import { Address } from 'services/api';

export const getFormattedAddress = (addressObj?: Address) => {
  if (!addressObj) return '';

  const { address, city, state_abbreviation, postcode } = addressObj;
  return `${address}, ${city}, ${state_abbreviation} ${postcode}`;
};
